// JsFromRoutes CacheKey 81ccea5b9f8efa21f22a5a45aebd76e3
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/brokers/tasks'),
  indexGet: /* #__PURE__ */ definePathHelper('get', '/brokers/tasks/*path'),
}
